export enum BrmInventoryTypes {
  CATEGORY,
  PRODUCTFAMILY,
  PRODUCTLINE,
  ASSET
}
